import { render, staticRenderFns } from "./MinhasLicitacoes.vue?vue&type=template&id=2ad7486a"
import script from "./MinhasLicitacoes.vue?vue&type=script&lang=js"
export * from "./MinhasLicitacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports